export default "__VITE_ASSET__CEKbHlCb__"